import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import "vant/es/dialog/style";
import _Dialog from "vant/es/dialog";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.keys.js";
import '@/utils/monitor-err';
import Vue from 'vue';
import App from './App';
import Drip from './drip';
import router from './router';
import store from './store';
import { isProd } from '@/config/';
import { mtguardInit } from './utils/mtguard';
import { handleCheckUserSession } from './utils/quickAppCheckLogin';
import getMaoyanPermission from 'drip/utils/permission';
import dayjs from 'dayjs';
import isToday from 'dayjs/plugin/isToday';
import { ERROR_TEXT } from '@/common/global';
import { owlAddError } from '@/utils/monitor-err/index';
import { globalReportError } from '@/utils/monitor-err/index'; // 细化异常名异常上报
import { needFetchWebviewConfig } from '@/utils/ssl';
import { getLionConfigWithStore, getLionConfig } from '@/common/lionConfig';
Vue.prototype.$ERROR_TEXT = ERROR_TEXT;
// 全局注册
Vue.use(_Dialog);

// 全局注册细化异常名异常上报方法
Vue.use(globalReportError);
if (!isProd) {
  require('@/utils/vconsole/');
  Vue.config.devtools = true;
}
Vue.config.productionTip = false;
Vue.config.errorHandler = function (e, vm, info) {
  console.error('errorHandler', e, vm, info);
  owlAddError(e);
};
Vue.config.warnHandler = function (msg, vm, trace) {
  owlAddError({
    name: msg,
    msg: {
      trace: trace
    }
  });
};
require('@/common/axios.config');

// 主入口
var main = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _window;
    var isListPage, shouldGetLocation;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          isListPage = /^#\/list\/.*/.test(location.hash || '');
          shouldGetLocation = true;
          if (!isListPage) {
            _context.next = 6;
            break;
          }
          _context.next = 5;
          return getMaoyanPermission([{
            scene: 'scene_show_category_list',
            permission: 'permission_location'
          }]);
        case 5:
          shouldGetLocation = _context.sent;
        case 6:
          _context.next = 8;
          return Promise.all([Drip.ready([], shouldGetLocation)]);
        case 8:
          mtguardInit();

          // 接口的调用必须放在mtguardInit 之后，不然发出的接口没有添加验签参数，导致验签失败
          try {
            if (needFetchWebviewConfig()) {
              getLionConfigWithStore('myWebview', {
                expires: '15M'
              });
            }
            if (Drip.UA.isNative) {
              getLionConfig('mrnJumpDetail').then(function (res) {
                if (res) {
                  window.MRN_JUMP_DETAIL_CONFIG = res;
                }
              }).catch(function (err) {
                console.warn(err);
              });
            }
          } catch (err) {}
          Drip.getUuid();
          if (Drip.UA.IS_QuickApp) {
            try {
              if (window.system && !window.system.onmessage) {
                window.system.onmessage = function (data) {
                  var recvData = JSON.parse(data) || {};
                  if (recvData.method === 'checkUserSession') {
                    handleCheckUserSession(recvData);
                  }
                };
              }
            } catch (e) {}
          }

          //  页面资源文件加载完成时间
          (_window = window) === null || _window === void 0 ? void 0 : _window.owl('addPoint', {
            position: 0,
            timeStamp: Date.now()
          });

          // if ( process.env.NODE_ENV === 'development' ) require( 'mocks' ).default.start()

          /* eslint-disable no-new */
          new Vue({
            el: '#app',
            router: router,
            store: store,
            template: '<App/>',
            components: {
              App: App
            }
          });
        /* eslint-enable no-new */
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function main() {
    return _ref.apply(this, arguments);
  };
}();
// 注册插件
dayjs.extend(isToday);
main();